import { CustomNavLink } from '../../routes';
import { ReactComponent as AccuratorLogo } from '../../../assets/images/logo-light.svg';
import { ReactComponent as ProjectIcon } from '../../../assets/svg/project.svg';
import { ReactComponent as StartIcon } from '../../../assets/svg/start.svg';
import { ReactComponent as InternIcon } from '../../../assets/svg/intern.svg';
import { ReactComponent as ActivityIcon } from '../../../assets/svg/activities.svg';
import { ReactComponent as SupplierIcon } from '../../../assets/svg/suppliers.svg';
import { ReactComponent as OrganizationIcon } from '../../../assets/svg/organization.svg';
import { ReactComponent as ReportsIcon } from '../../../assets/svg/reports.svg';
import { ReactComponent as VideosIcon } from '../../../assets/svg/videos.svg';
import { ReactComponent as MarketingIcon } from '../../../assets/svg/marketingIcon.svg';
import { ReactComponent as NewsIcon } from '../../../assets/svg/news.svg';
import { ReactComponent as BusinessCardIcon } from '../../../assets/svg/businessCard.svg';
import { ReactComponent as FlyerTakenIcon } from '../../../assets/svg/flyerTakenIcon.svg';
import RequestQuoteIcon from '../../../components/svgs/requestQuoteIcon';

import appState from '../../../state/AppStateContainer';

import './leftMenuBar.scss';
import NotificationCounter from '../NotificationCounter/NotificationCounter';
import { useEffect } from 'react';
import { ServiceChat } from '../../../services/service-chat';
import { ServiceProjects } from '../../../services/service-projects';
import _ from 'lodash';

export default function leftMenuBar() {
  const superAdminCheck = appState.isSuperAdmin() && appState.getCurrentOrgSlug() === 'superadmin';
  const { project, internalChat } = appState.getGlobalNotifications();
  const menuItems = [
    {
      title: 'Start',
      to: '/dashboard',
      icon: <StartIcon />,
      product: "PURCHASING",
    },
    {
      title: 'Projekt',
      to: '/projects',
      icon: <ProjectIcon />,
      product: "PURCHASING",
      notifications: project,
    },
    {
      title: 'Leverantörer',
      to: '/supplier-database',
      icon: <SupplierIcon />,
      counter: appState.isAdminRole() ? appState.getSupplierApplicationCount() : 0,
      product: "PURCHASING",
    },
    {
      title: 'Aktiviteter',
      to: '/tasks',
      icon: <ActivityIcon />,
      product: "PURCHASING",
    },
    {
      title: 'Mottagna förfrågningar',
      to: '/requests',
      icon: <RequestQuoteIcon color={undefined} />,
      product: "SALES",
    },
    {
      title: 'Publicerade förfrågningar',
      to: '/published-requests',
      icon: <FlyerTakenIcon color={undefined} />,
      product: "SALES",
    },
    {
      title: 'Marknadsföring',
      to: '/marketing',
      icon: <MarketingIcon color={undefined} className='menu-list-marketing-icon' />,
      product: "SALES",
    },
    {
      title: 'Presentation',
      to: '/supplier-presentation',
      icon: <BusinessCardIcon color={undefined} />,
      product: "SALES",
    },
    {
      title: 'Användare',
      to: '/chat',
      icon: <InternIcon />,
      notifications: internalChat,
    },
    {
      title: 'Organisationer',
      to: '/organizations',
      icon: <OrganizationIcon />,
    },
    {
      title: 'Rapporter',
      to: '/reports',   
      icon: <ReportsIcon />,   
    },
    {
      title: 'Fakturor',
      to: '/invoices',
      icon: <ReportsIcon />,
    },
    {
      title: 'Instruktionsfilmer',
      to: '/help',
      icon: <VideosIcon />,
      product: "PURCHASING",
    },
    {
      title: 'Uppdateringar',
      to: '/updates',
      icon: <NewsIcon />, 
    },
  ];

  useEffect(() => {
    (async () => {
      let projectNotifications;
      if (!appState.isClientRole()) {
        projectNotifications = (await ServiceProjects.getCounter())?.count;
      } else {
        projectNotifications = 0;
      }
      appState.setGlobalNotifications({ project: projectNotifications });
    })();
    (async () => {
      const notifications = await ServiceChat.getNotifications();
      const chatNotification = notifications.reduce((a, b) => a + b.count, 0);
      appState.setGlobalNotifications({ internalChat: chatNotification });
    })();
  }, []);

  const isActiveRoute = (link: string) => location.pathname.includes(link);

  return (
    <div className="app-menu-left conv--wrapper">
      <CustomNavLink to="/dashboard">
        <div className="logo-wrapper">
          <AccuratorLogo />
        </div>
      </CustomNavLink>

      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <div className='menu-list'>
          {menuItems?.map(menu => {
            if (superAdminCheck && (menu.to === '/projects' || menu.to === '/tasks' || menu.to === '/requests' || menu.to === '/marketing' || menu.to === '/supplier-presentation' || menu.to === '/published-requests')) return null;
            if (appState.isClientRole() && (menu.to === '/supplier-database' || menu.to === '/tasks')) return null;
            if (!superAdminCheck && (menu.to === '/organizations' || menu.to === '/reports' || menu.to === '/invoices')) return null;
            if (!superAdminCheck && menu.product && !(appState.getActiveProducts().includes(menu.product))) return null;
            return (
              <CustomNavLink to={menu.to} key={menu.to} className={isActiveRoute(menu.to) ? 'active' : ''}>
                {menu.icon}
                {menu.title}
                {menu.counter ? (<NotificationCounter counter={menu.counter} style={{marginLeft: "8px", backgroundColor: "var(--gray-600)"}} />) : (null)}
                {menu.notifications ? (<NotificationCounter counter={menu.notifications} style={{ marginLeft: "8px", }} />) : null}
              </CustomNavLink>
            );
          })}
        </div>
      </div>
    </div>
  );
}
